<template>
  <div class="right_col" role="main">
    <div class="page-title">
      <div class="title_left">
        <h3>
          {{ title }}
          <span v-if="isConfirmView"
            >- {{ $t('orderPage.inputConfirmation') }}</span
          >
        </h3>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="x_panel">
          <div class="x_content form-horizontal form-label-left">
            <alert
              :title="title"
              :success-message="$t('common.isSuccess')"
              :error-message="$t('common.isFailure')"
              :alerts="alerts"
              :errors="errors"
              :display="alertDisplay"
              @closeAlert="closeAlert"
            />

            <div class="form-group">
              <label class="control-label col-md-3 col-sm-3"
                >{{ $t('common.implementationGroup') }}：
                <span class="required">*</span></label
              >
              <div class="col-md-5 col-sm-5 col-xs-12">
                <textarea
                  id="shops"
                  v-model="inputShopValues"
                  v-validate="ValidRules.shops"
                  :data-vv-as="$t('common.implementationGroup')"
                  type="text"
                  name="shops"
                  required="required"
                  class="form-control col-md-7 col-xs-12"
                  rows="10"
                  style="resize: none"
                  readonly
                >
                </textarea>
                <div class="clearfix"></div>
                <div
                  v-show="validator.has('shops')"
                  class="alert alert-danger"
                  role="validater"
                >
                  <ul>
                    <li
                      v-for="(message, index) in validator.collect('shops')"
                      :key="index"
                    >
                      {{ message }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <button
                  id="add-shop-btn"
                  :disabled="isConfirmView"
                  @click="showModal('shop')"
                  class="btn btn-success"
                >
                  {{ $t('common.edit') }}
                </button>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-md-3 col-sm-3"
                >{{ $t('adPage.orderMenu') }}：
                <span class="required">*</span></label
              >
              <div class="col-md-5 col-sm-5 col-xs-12">
                <input
                  id="order"
                  v-model="inputOrderValues"
                  v-validate="ValidRules.order"
                  :data-vv-as="$t('adPage.orderMenu')"
                  :placeholder="$t('common.itemName')"
                  type="text"
                  name="order"
                  class="form-control"
                  readonly
                />
                <div
                  v-show="validator.has('order')"
                  class="alert alert-danger"
                  role="validater"
                >
                  <ul>
                    <li
                      v-for="(message, index) in validator.collect('order')"
                      :key="index"
                    >
                      {{ message }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <button
                  :disabled="isConfirmView"
                  @click="showModal('order')"
                  class="btn btn-success"
                >
                  {{ $t('common.select') }}
                </button>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-md-3 col-sm-3"
                >{{ $t('common.recommendMenu') }}：
                <span class="required">*</span></label
              >
              <div class="col-md-5 col-sm-5 col-xs-12">
                <textarea
                  id="recommend"
                  v-model="inputRecommendValues"
                  v-validate="ValidRules.recommend"
                  :data-vv-as="$t('common.recommendMenu')"
                  type="text"
                  name="recommend"
                  required="required"
                  class="form-control col-md-7 col-xs-12"
                  rows="10"
                  style="resize: none"
                  readonly
                >
                </textarea>
                <div class="clearfix"></div>
                <div
                  v-show="validator.has('recommend')"
                  class="alert alert-danger"
                  role="validater"
                >
                  <ul>
                    <li
                      v-for="(message, index) in validator.collect('recommend')"
                      :key="index"
                    >
                      {{ message }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <button
                  id="add-item-btn"
                  :disabled="isConfirmView"
                  @click="showModal('recommend')"
                  class="btn btn-success"
                >
                  {{ $t('common.edit') }}
                </button>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-md-3 col-sm-3" for="startAt"
                >{{ $t('adPage.recommendPeriod') }}
                <template v-if="!isJp">({{ timezone }})</template>：
                <span class="required">*</span></label
              >
              <div class="col-md-5 col-sm-5 col-xs-12">
                <strong>
                  <input
                    id="startAt"
                    ref="startAt"
                    v-model="displayStartAt"
                    v-validate="ValidRules.startAt"
                    :data-vv-as="$t('adPage.recommendPeriodStart')"
                    :disabled="isConfirmView"
                    type="date"
                    name="startAt"
                  />
                </strong>
                <label style="margin-left: 10px" for="endAt"
                  >{{ $t('eventInformationPage.endDate') }}：</label
                >
                <strong>
                  <input
                    id="endAt"
                    ref="endAt"
                    v-model="displayEndAt"
                    v-validate="ValidRules.endAt"
                    :data-vv-as="$t('adPage.recommendPeriodEnd')"
                    :disabled="isConfirmView"
                    type="date"
                    name="endAt"
                  />
                </strong>
                <div
                  v-show="validator.has('startAt') || validator.has('endAt')"
                  class="alert alert-danger"
                  role="validater"
                >
                  <ul>
                    <li
                      v-for="(message, index) in validator.collect('startAt')"
                      :key="index"
                    >
                      {{ message }}
                    </li>
                  </ul>
                  <ul>
                    <li
                      v-for="(message, index) in validator.collect('endAt')"
                      :key="index"
                    >
                      {{ message }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="ln_solid"></div>
            <div class="form-group">
              <div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3">
                <button @click="back" class="btn btn-default">
                  {{ $t('common.back') }}
                </button>
                <button
                  v-if="!isConfirmView"
                  @click="confirm"
                  class="btn btn-success"
                >
                  {{ $t('common.inputComplete') }}
                </button>
                <button v-else @click="submit" class="btn btn-success">
                  {{ $t('orderPage.registration') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal
      v-if="isShowModal"
      :current="current"
      :list-items="listItems"
      @close="isShowModal = false"
      @valueInput="valueInput"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import { getServerDateTime, getTimezone } from '@/utility/time'
import alert from '@/mixin/alert'

import Alert from '@/components/common/alert/Alert'
import Modal from '@/components/common/modal/AdRegistModal'
import OrderRecommendRequest from '@/http/OrderRecommendRequest'
import ValidRules from '@/validator/OrderRecommendRules'

export default {
  components: {
    Alert,
    Modal,
  },
  mixins: [alert],
  data() {
    return {
      displayStartAt: '',
      displayEndAt: '',
      isEdit: false,
      isConfirmView: false,
      current: String,
      isShowModal: false,
      title: this.$t('adPage.recommendOnOrderRegistration'),
      inputShopValues: '', // 選択済みグループの名前の羅列
      allGroupDatas: [], // グループ選択モーダルに表示するグループ情報と選択した内容
      orderMeneDatas: [], // 注文メニュー選択モーダルに表示する商品情報と選択した内容
      inputOrderValues: '', // 選択済み注文メニュー
      inputRecommendValues: '', // 選択済みレコメンドメニューの名前の羅列
      ValidRules: ValidRules,
    }
  },
  computed: {
    ...mapGetters({
      getGroups: 'shop/getGroupToShops',
      getItems: 'item/getItems',
      getOrderRecommendById: 'orderRecommend/getOrderRecommendById',
      language: 'settings/getLanguage',
    }),
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJp() {
      return this.defaultLanguage === 'ja'
    },
    orderRecommend() {
      return this.getOrderRecommendById(this.$route.params.id)
    },
    timezone() {
      return getTimezone()
    },
  },
  mounted() {
    this.createGroupData()
    this.createItemData()

    if (this.$route.name === 'orderRecommendFormEdit') {
      this.getStoreData(this.$route.params.id)
      this.isEdit = true
      this.title = this.$t('adPage.editRecommendOnOrder')
    }
  },
  methods: {
    createItemData: function() {
      const data = this.getItems

      // 注文メニューの作成
      this.orderMeneDatas = data.list.map((item) => {
        let toppingItem = ''
        Object.values(item.toppings).forEach((topping) => {
          toppingItem += topping + ' '
        })
        return [
          {
            type: 'radio',
            id: item.itemCode,
            name: 'order',
            value: item.itemCode,
            checked: 0,
          },
          item.itemCode,
          item.names[this.language],
          item.itemKind.name,
          toppingItem,
        ]
      })

      // レコメンドメニューの作成
      this.recommendItemDatas = data.list.map((item) => {
        let toppingItem = ''
        Object.values(item.toppings).forEach((topping) => {
          toppingItem += topping + ' '
        })
        return [
          {
            type: 'checkbox',
            id: item.itemCode,
            checked: false,
            target: 'recomend',
          },
          item.itemCode,
          item.names[this.language],
          item.itemKind.name,
          toppingItem,
        ]
      })
    },

    // 実施グループの作成
    createGroupData: function() {
      const data = this.getGroups
      this.allGroupDatas = data.map((item) => {
        const names = item.shops.map((shop) => {
          return shop.name
        })
        const body = names.join('　')

        return [
          {
            type: 'checkbox',
            id: item.groupId,
            checked: false,
            target: 'shop',
          },
          item.groupId,
          { type: 'accordion', id: item.groupId, title: item.name, body: body },
        ]
      })
    },
    getStoreData: function() {
      // 実施グループ
      let groupNameList = []
      this.orderRecommend.groupList.forEach((item) => {
        const index = this.allGroupDatas.findIndex(
          (group) => group[1] === item.groupId
        )
        if (index > -1) {
          this.allGroupDatas[index][0].checked = true
          groupNameList.push(item.name)
        }
      })
      this.inputShopValues = groupNameList.join('\n')

      // 注文メニュー
      const orderMenuIndex = this.orderMeneDatas.findIndex(
        (item) => item[1] === this.orderRecommend.itemCode
      )
      if (orderMenuIndex > -1) {
        this.orderMeneDatas.forEach((item) => {
          item[0].checked = this.orderRecommend.itemCode
        })
        this.inputOrderValues = this.orderMeneDatas[orderMenuIndex][2]
      }

      // レコメンドメニュー
      let recommendNameList = []
      this.orderRecommend.recommendList.forEach((item) => {
        const index = this.recommendItemDatas.findIndex(
          (recommend) => recommend[1] === item.itemCode
        )
        if (index > -1) {
          this.recommendItemDatas[index][0].checked = true
          recommendNameList.push(item.name)
        }
      })
      this.inputRecommendValues = recommendNameList.join('\n')

      // レコメンド期間
      this.displayStartAt = getServerDateTime(
        this.orderRecommend.displayStartAt
      ).format('YYYY-MM-DD')
      this.displayEndAt = getServerDateTime(
        this.orderRecommend.displayEndAt
      ).format('YYYY-MM-DD')
    },
    back: function() {
      if (this.isConfirmView) {
        this.isConfirmView = false
      } else {
        this.$router.push({ name: 'orderRecommend' })
      }
    },
    confirm: function() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.isConfirmView = true
        }
      })
    },
    submit: function() {
      const itemCode = this.orderMeneDatas[0][0].checked

      let groupIds = []
      this.allGroupDatas.forEach((item) => {
        if (item[0].checked) {
          groupIds.push(item[1])
        }
      })

      let recommendItemCodes = []
      this.recommendItemDatas.forEach((item) => {
        if (item[0].checked) {
          recommendItemCodes.push(item[1])
        }
      })

      const params = {
        itemCode: itemCode,
        groupIds: groupIds,
        recommendItemCodes: recommendItemCodes,
        displayStartAt: global
          .moment(this.displayStartAt)
          .format('YYYY-MM-DD 00:00:00'),
        displayEndAt: global
          .moment(this.displayEndAt)
          .format('YYYY-MM-DD 23:59:59'),
      }

      const request = new OrderRecommendRequest()
      if (this.isEdit) {
        request
          .update(this.$route.params.id, params)
          .then(() => {
            this.$router.push({
              name: 'orderRecommend',
              params: { succeeded: true, title: this.title },
            })
          })
          .catch((err) => {
            this.isConfirmView = false
            this.openErrorAlert(err.response.data)
            console.log(err.response)
          })
      } else {
        // 新規登録
        request
          .insert(params)
          .then(() => {
            this.$router.push({
              name: 'orderRecommend',
              params: { succeeded: true, title: this.title },
            })
          })
          .catch((err) => {
            this.isConfirmView = false
            this.openErrorAlert(err.response.data)
            console.log(err.response)
          })
      }
    },

    // モーダルで選択した内容を取得して、画面に表示する
    valueInput: function(inputValues) {
      switch (this.current) {
        case 'shop':
          this.inputShopValues = inputValues.join('\n')
          break
        case 'order':
          this.inputOrderValues = inputValues.join('\n')
          break
        case 'recommend':
          this.inputRecommendValues = inputValues.join('\n')
          break
        default:
          break
      }
      this.isShowModal = false
    },

    // モーダルの表示
    showModal: function(current) {
      this.current = current
      switch (this.current) {
        case 'shop':
          this.listItems = this.allGroupDatas
          break
        case 'order':
          this.listItems = this.orderMeneDatas
          break
        case 'recommend':
          this.listItems = this.recommendItemDatas
          break
        default:
          break
      }
      this.isShowModal = true
    },
  },
}
</script>
